import {ClientContextClass} from '@packages/client';

export const defaultClient = new ClientContextClass();
